export default __webpack_public_path__ + "static/media/SWT0280.34I-26771_-16383_0.e9d642ff.jpg";